(function () {
    'use strict';

    angular.module("imApp").factory("serviceObjectTypeIntsService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1743,
                    parameters: parms || {}
                });
            },
            listIntervals: function (parms) {
                return $ihttp.post({
                    method: 1744,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
